import React from 'react';

const Services = () => {
  const services = [
    {
      title: "Commodity Trading",
      description: "Broad portfolio including bulk sugar, maize, wheat, small grains, and agro-products sourced from key global markets.",
      items: ["Maize (Corn)", "Bulk Sugar", "Wheat", "Small Grains", "Agro-products", "Bulk Fertilizers", "Crude and Refined Edible Oils", "Bulk Yellow Sulphur"],
      icon: "🌾"
    },
    {
      title: "Procurement & Supply",
      description: "End-to-end solutions from sourcing to final delivery, ensuring seamless supply chain management.",
      items: ["Single-source Procurement", "Quality Assurance", "Timely Delivery", "Supply Chain Management"],
      icon: "📦"
    },
    {
      title: "Supply Chain Credit Solutions",
      description: "Innovative trade finance solutions to optimize cash conversion cycles and improve liquidity.",
      items: ["Custom Credit Terms", "Cash Flow Management", "Financial Stability", "Competitive Edge"],
      icon: "💰"
    }
  ];

  return (
    <section id="services" className="services-section">
      {/* Background Pattern Overlay */}
      <div className="background-pattern"></div>
      
      <div className="container">
        {/* Header Section */}
        <div className="services-header">
          <h1>Our Services</h1>          
        </div>

        {/* Services Grid */}
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card-modern">
              <div className="service-icon">{service.icon}</div>
              <h3>{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.items.map((item, idx) => (
                  <li key={idx}>{item}</li>
                ))}
              </ul>
              <button className="service-more-btn">MORE</button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;